<template>
  <sdCards :title="$t('pages.apps.images.logo-title')">
    <a-row type="flex" justify="space-between">
      <a-col :span="6">
        <img :src="app.image" height="100" style="max-width: 500px" />
      </a-col>
      <a-col :offset="8" :span="10">
        <a-form layout="vertical">
          <a-form-item :label="$t('pages.apps.images.input-logo-title')">
            <a-upload
              class="sDash_upload-basic"
              name="file"
              :multiple="false"
              :headers="fileData.headers"
              :action="fileData.endpoint + $endpoints.app_images_logo_set + '/' + app_id"
              :before-upload="beforeUpload"
              @change="logoChange"
            >
              <span class="sDash_upload-text">{{ $t('pages.apps.images.input-logo-placeholder') }}</span>
              <a to="#" class="sDash_upload-browse"> {{ $t('pages.apps.images.input-logo-button') }} </a>
            </a-upload>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </sdCards>
  <sdCards :title="$t('pages.apps.images.screen-title')">
    <div class="clearfix">
      <a-upload
        :action="fileData.endpoint + $endpoints.app_images_set + '/' + app_id"
        list-type="picture-card"
        :headers="fileData.headers"
        v-model:file-list="fileList"
        :multiple="false"
        :before-upload="beforeUpload"
        @change="screenChange"
        :remove="removeImage"
        @preview="handlePreview"
      >
        <div class="ant-upload-text">{{ $t('pages.apps.images.input-screen-button') }}</div>
      </a-upload>
    </div>
  </sdCards>
</template>

<script>
import store from '@/vuex/store';
import { mapGetters } from 'vuex';
export default {
  name: 'Images',
  data() {
    return {
      fileData: {
        endpoint: process.env.VUE_APP_API_ENDPOINT,
        headers: {
          authorization: 'Bearer ' + store.state.auth.jwt_token,
        },
      },
      fileList: [],
      app_id: this.$route.params.id,
    };
  },
  methods: {
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('pages.apps.images.error-type'));
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error(this.$t('pages.apps.images.error-size'));
      }
      return isJpgOrPng && isLt2M;
    },
    screenChange(info) {
      if (info.file.status === 'done') {
        var response = JSON.parse(info.file.xhr.response);
        if (response.status) {
          this.$message.success(`${info.file.name} ` + ' ' + this.$t('pages.apps.images.success-upload'));
          this.fileList[this.fileList.length - 1].uid = response.data.id;
          this.fileList[this.fileList.length - 1].url = response.data.url;
        } else {
          this.$message.error(`${info.file.name} ` + ' ' + this.$t('pages.apps.images.error-upload'));
          this.fileList.splice(this.fileList.length - 1, 1);
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} ` + ' ' + this.t('pages.apps.images.error-upload'));
      }
    },
    logoChange(info) {
      if (info.file.status === 'done') {
        var response = JSON.parse(info.file.xhr.response);
        if (response.status) {
          this.$message.success(`${info.file.name}` + ' ' + this.$t('pages.apps.images.success-upload'));
          this.app.image = response.data.url;
        } else {
          this.$message.error(`${info.file.name} ` + ' ' + this.$t('pages.apps.images.error-upload'));
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} ` + ' ' + this.$t('pages.apps.images.error-upload'));
      }
    },
    handlePreview(info) {
      window.open(info.big_url, '_blank');
    },
    getData() {
      this.data = [];
      const formData = {
        app_id: this.app_id,
      };
      this.$appAxios.post(this.$endpoints.app_images_get, formData).then((resp) => {
        if (resp.data.status) {
          var _this = this;
          resp.data.data.forEach(function (item, index) {
            _this.fileList.push({
              uid: item.id,
              name: 'image.png',
              status: 'done',
              url: item.thumb_url || item.url,
              big_url: item.url,
            });
          });
        }
      });
    },
    removeImage(info) {
      if (!confirm(this.$t('pages.apps.images.question-delete'))) {
        return false;
      }
      const formData = {
        app_id: this.app_id,
        image_id: info.uid,
      };
      this.$appAxios.post(this.$endpoints.app_images_delete, formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('pages.apps.images.success-delete'));
          return true;
        } else {
          this.$message.error(resp.data.message);
          return false;
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapGetters({
      app: 'application/app_detail',
    }),
  },
};
</script>